import { conditionalRender } from './conditionalRender';
import LoadingPage from './LoadingPage';

export const loadingPageWhileLoading = <P>(isLoading: (props: P) => boolean) =>
  conditionalRender(isLoading, LoadingPage);
